export function routes($stateProvider) {
    $stateProvider
        .state('app.funciona.processos', {
        url: '/processos',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.funciona.processos.list1', {
        url: 'OLD?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Listagem de Processos',
        role: ['funcionaVerProcessos'],
        controller: 'FunProcessosListController',
        controllerAs: 'vm',
        template: require('./list/view.html'),
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.funciona.processos.list', {
        url: '?{page:int}&{limit:int}&sortBy&filter',
        title: 'Listagem de Processos',
        role: ['funcionaVerProcessos'],
        template: '<processos-list></processos-list>',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.funciona.processos.details', {
        url: '/{id:int}',
        title: 'Detalhes de Processo',
        template: require('./details/view.html'),
        role: ['funcionaVerProcessos'],
        controller: 'FunProcessosDetailsController',
        controllerAs: 'vm',
    })
        .state('app.funciona.processos.edit', {
        url: '/edit/{id:int}',
        title: 'Editar processo',
        template: '<fun-processo-form></fun-processo-form>',
        role: ['funcionaVerTodosProcessos'],
    });
}
routes.$inject = ['$stateProvider'];
